
export class TipoProcessamento {

    public id: string;
    public nome: string;

    constructor(){
        
    }
}
